/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useState } from "react";
import { SuccessFetch } from "types";
import { useApi } from "utils";
import { Location } from "types";

type Response = {
  payload: Location[];
};

export function useLocationList() {
  const api = useApi();
  const [data, setData] = useState<Location[]>([]);
  const [isLoading, setLoading] = useState(false);

  const fetchData = () => {
    setLoading(true);

    api
      .get("/location/")
      .then((res: SuccessFetch<Response>) => {
        const data = res.data.payload ?? [];
        setData(data);
      })
      .catch(() => setData([]))
      .finally(() => setLoading(false));
  };

  const refetch = () => fetchData();

  useEffect(() => {
    fetchData();

    return () => {
      setData([]);
      setLoading(false);
    };
  }, []);

  return {
    data,
    isLoading,
    refetch,
    dropdown: data.map((item) => ({
      label: item.location_name,
      value: item.location_id.toString()
    }))
  };
}
